<template>
    <CNCPunch></CNCPunch>
</template>

<script>
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../../Layouts/GuestLayout.vue")
);
const CNCPunch = defineAsyncComponent(() =>
    import("../../../components/ITDepartment/TV/CNCPunch.vue")
);

export default {
    name: "CNC_Punch_TV", //The name you are in should not equal the name of the component you are importing.
    components: { CNCPunch, GuestLayout },
};
</script>
